import { Event } from '@axiom/const';

export const calculateLatestCheckInActivity = activities => {
  const latestCheckInActivities = activities.filter(activity =>
    Object.values(Event.LAST_CHECK_IN_VALID_PURPOSES).includes(activity.purpose)
  );
  latestCheckInActivities.sort(
    (a, b) => new Date(b.scheduledDate) - new Date(a.scheduledDate)
  );
  return latestCheckInActivities[0];
};

export * as candidateOpportunityStatusUtils from './candidateOpportunityStatus';
export * from './candidateStateConstants';
export * from './candidate-opportunity-utils';
export * from './candidate-profile-status-state-machine';
export * from './candidate-profile-utils';
export * from './candidate-profile-issues-utils';
export * from './candidate';
export * from './country-util';
export * from './chunk';
export * from './currency-util';
export * from './date';
export * from './embargo';
export * from './engagements-util';
export * from './general';
export * from './location';
export * from './ml-recommended-util';
export * from './retry';
export * from './password-strength-util';
export * from './position';
export * from './props';
export * from './url-slugs-util';
export * from './user';

/*
  Per-function paths, not the `lodash/fp` barrel. Importing the barrel runs
  `baseConvert` over the whole lodash API, which retains the test environment's
  global: jest's `--detectLeaks` fails on any suite that reaches this file, and
  in-band CI segments accumulate a jsdom environment per suite until the heap is
  gone. Each `lodash/fp/<fn>` module converts only itself and is clean.
*/
export { default as findKey } from 'lodash/fp/findKey';
export { default as mergeAll } from 'lodash/fp/mergeAll';
export { default as omit } from 'lodash/fp/omit';
export { default as sortBy } from 'lodash/fp/sortBy';
